import { render } from "./SavedOutliers.vue?vue&type=template&id=170dd268"
import script from "./SavedOutliers.vue?vue&type=script&lang=js"
export * from "./SavedOutliers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__